import { Fragment } from "react";
import { Stage, ExpandTable, BlockHead, Explica, Detalhe } from "../components/primitives";

const SKILLS = [
  {
    id: "diagnostico-meta-ads",
    nome: "Diagnóstico Meta Ads",
    icone: "⟁",
    cor: "var(--danger)",
    comando: "/diagnostico-meta-ads [pasta-cliente]",
    descricao: "Diagnóstico estruturado de campanhas Meta Ads de um cliente. Separa operação ativa, pausadas temporárias e histórico encerrado — e entrega lista priorizada de oportunidades.",
    quando: [
      "CPL subiu mais de 20% sem alteração de criativos",
      "Ao assumir uma conta nova para diagnóstico inicial",
      "Cliente questionou o resultado das campanhas",
      "Antes de reunião mensal de performance",
      "ROAS caiu sem causa aparente",
    ],
    porque: "Misturar campanhas desativadas com a operação ativa distorce todas as métricas. O diagnóstico estruturado separa isso antes de analisar — e entrega ações em 3 horizontes de tempo: 48h, 1-2 semanas e estratégico.",
    entrega: "Visão geral + pontos críticos + oportunidades priorizadas",
    exemplo: "/diagnostico-meta-ads CLIENTES/Dr-Silva",
    path: "C:\\Users\\rcamp\\.claude\\skills\\diagnostico-meta-ads.md",
  },
  {
    id: "criar-conteudo-semanal",
    nome: "Criar Conteúdo Semanal",
    icone: "◻",
    cor: "var(--cat-violet)",
    comando: "/criar-conteudo-semanal [nome-cliente-medico]",
    descricao: "Gera uma semana completa de conteúdo em uma rodada: 7 posts para a RC2Clicks, 2 posts para o cliente médico ortopedista e 2–3 criativos completos para Meta Ads — com copy, briefing visual para Canva e roteiro para CapCut.",
    quando: [
      "Todo início de semana para planejar o conteúdo de 7 dias",
      "Quando estiver sem ideias ou travado na produção",
      "Antes de reunião com cliente para já ter criativos prontos para apresentar",
      "Para não acumular a produção de conteúdo da semana",
    ],
    porque: "Criar conteúdo do zero toda semana para a agência + cliente médico + Meta Ads consome horas. Essa skill entrega tudo estruturado de uma vez: copy, briefing visual slide a slide, roteiro para CapCut e variações A/B para testar nos anúncios — com as regras CFM já aplicadas.",
    entrega: "7 posts agência + 2 posts cliente + 2–3 criativos ads (copy A/B + briefing Canva + roteiro CapCut)",
    exemplo: '/criar-conteudo-semanal "Dr. Victor Couto"',
    path: "C:\\Users\\rcamp\\.claude\\skills\\criar-conteudo-semanal.md",
    parametros: [
      { param: "nome-cliente-medico", descricao: 'Opcional. Nome do cliente ortopedista. Ex: "Dr. Victor Couto". Se omitido, gera conteúdo genérico de ortopedia.' },
    ],
    output: [
      "RC2Clicks → RC2CLICKS-EMPRESA\\conteudo\\semana-[data]\\",
      "Cliente médico → CLIENTES\\[cliente]\\copies\\semana-[data]\\",
      "Meta Ads → CRIATIVOS\\[cliente]\\semana-[data]\\",
    ].join("\n"),
  },
  {
    id: "prospectar-leads-medicos",
    nome: "Prospectar Leads Médicos",
    icone: "◎",
    cor: "var(--success)",
    comando: "/prospectar-leads-medicos [cidade] [especialidade] [qtd]",
    descricao: "Levantamento semanal de leads médicos com auditoria digital completa: site, Instagram, Biblioteca de Anúncios do Meta e Google Meu Negócio. Entrega score, justificativa e script de abordagem personalizado para cada lead.",
    quando: [
      "Toda semana — para nunca ficar sem prospecção ativa",
      "Antes de decisão de entrar em um novo nicho médico",
      "Quando a carteira de clientes precisa crescer",
      "Para preparar uma reunião de diagnóstico com um prospect específico",
    ],
    porque: "A procrastinação em prospecção mata o crescimento silenciosamente. Essa skill força a ação: busca, audita e entrega os 5 melhores leads da semana prontos para abordagem — com script personalizado baseado em dados reais do prospect.",
    entrega: "5 arquivos .md (um por lead) + resumo semanal com ranking e checklist",
    exemplo: '/prospectar-leads-medicos "São Paulo" ortopedista 5',
    path: "C:\\Users\\rcamp\\.claude\\skills\\prospectar-leads-medicos.md",
    parametros: [
      { param: "cidade", descricao: 'Cidade-alvo. Default: "São Paulo"' },
      { param: "especialidade", descricao: 'Especialidade médica. Default: "ortopedista"' },
      { param: "qtd", descricao: "Quantidade de leads auditados. Default: 5" },
    ],
    output: "C:\\Users\\rcamp\\Documents\\RC2Clicks\\CLIENTES\\PROSPECTOS\\[especialidade]-[cidade]\\semana-[data]\\",
  },
];

const MONO = {
  background: "var(--surface)", borderRadius: 12, padding: "8px 14px",
  fontFamily: "var(--font-data)", fontSize: 12, color: "var(--ink)", lineHeight: 1.5,
  border: "1px solid var(--line)", overflowX: "auto",
};

function SkillDetail({ skill }) {
  return (
    <div className="detail-grid">
      <Detalhe label="O que faz">{skill.descricao}</Detalhe>
      <div className="detalhe">
        <span className="eyebrow">Quando usar</span>
        <ul style={{ margin: 0, paddingLeft: 18, display: "grid", gap: 2 }}>
          {skill.quando.map((w, i) => <li key={i}>{w}</li>)}
        </ul>
      </div>
      <Detalhe label="Por que usar">{skill.porque}</Detalhe>
      {skill.parametros && (
        <div className="detalhe">
          <span className="eyebrow">Parâmetros</span>
          <dl className="facts">
            {skill.parametros.map((p) => (
              <Fragment key={p.param}><dt><code>{p.param}</code></dt><dd>{p.descricao}</dd></Fragment>
            ))}
          </dl>
        </div>
      )}
      <div className="detalhe"><span className="eyebrow">Exemplo de uso</span><div style={MONO}>{skill.exemplo}</div></div>
      {skill.output && <div className="detalhe"><span className="eyebrow">Onde os arquivos são salvos</span><div style={MONO}>{skill.output}</div></div>}
      <dl className="facts">
        <dt>Entrega</dt><dd>{skill.entrega}</dd>
        <dt>Arquivo</dt><dd><code style={{ fontSize: 12 }}>{skill.path}</code></dd>
      </dl>
    </div>
  );
}

export function SkillsView() {
  return (
    <div className="view" style={{ maxWidth: 1040 }}>

      {/* Palco */}
      <Stage
        path="skills"
        title="Skills do"
        hl="Claude Code"
        lead={<>{SKILLS.length} skills: cada uma é um protocolo completo, chamado por um comando no Claude Code.</>}
      />

      <div style={{ display: "grid", gap: 8, marginBottom: 8 }}>
        <Explica title="Como usar uma skill">
          No terminal do Claude Code, digite <code>/nome-da-skill [parâmetros opcionais]</code>. As skills ficam em{" "}
          <code>C:\Users\rcamp\.claude\skills\</code>.
        </Explica>
        <Explica title="Adicionar nova skill">
          Peça ao Claude Code: <em>"Crie uma skill para [descreva o protocolo]"</em>. O arquivo é salvo em{" "}
          <code>C:\Users\rcamp\.claude\skills\</code> e aparece aqui depois que esta tela for atualizada.
        </Explica>
      </div>

      <BlockHead title="Skills disponíveis" sub="Uma linha por skill. Clique para ver quando usar e um exemplo." />
      <ExpandTable
        rows={SKILLS}
        minWidth={600}
        columns={[
          { key: "nome", label: "Skill", render: (s) => (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
              <span aria-hidden="true" style={{ color: s.cor, width: 18, textAlign: "center" }}>{s.icone}</span>
              <span className="name">{s.nome}</span>
            </span>
          ) },
          { key: "comando", label: "Comando", render: (s) => <code style={{ fontFamily: "var(--font-data)", fontSize: 12, color: "var(--muted)" }}>{s.comando}</code> },
          { key: "entrega", label: "Entrega", render: (s) => <span className="sub">{s.entrega}</span> },
        ]}
        detail={(s) => <SkillDetail skill={s} />}
      />
    </div>
  );
}
